export const SV_BANKS = [
  { value: 'agricola', label: 'Banco Agricola' },
  { value: 'cuscatlan', label: 'Banco Cuscatlan' },
  { value: 'davivienda', label: 'Davivienda' },
  { value: 'bac', label: 'BAC Credomatic' },
  { value: 'promerica', label: 'Banco Promerica' },
  { value: 'industrial', label: 'Banco Industrial' },
  { value: 'hipotecario', label: 'Banco Hipotecario' },
  { value: 'azul', label: 'Banco Azul' },
  { value: 'g_t', label: 'Banco G&T Continental' },
] as const

export type SvBankCode = (typeof SV_BANKS)[number]['value']

const SV_BANK_CODES = new Set<string>(SV_BANKS.map((bank) => bank.value))

export function isSvBankCode(value: string): value is SvBankCode {
  return SV_BANK_CODES.has(value)
}

export function getSvBankLabel(value: string): string {
  return SV_BANKS.find((bank) => bank.value === value)?.label ?? ''
}
